export default {"src":"/_next/static/media/right_quote.6d3ba27c.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};